// src/hooks/useSocketCommands.ts
import { useCallback } from 'react';
import { socketService } from '../socket/SocketService'; // 根据实际路径调整
import { randoMessageId } from '../util/author';
import {AnalysisTaskSubProcess, CommandType, GetImagesParams, suggestionProps} from "../types/taskFlow.types";
import {getLang} from "../util/storage"; // 根据实际路径调整

interface TaskParams {
  toolName: string;
  parameters: {
    inputText: string;
    [key: string]: any;
  };
}

export const useSocketCommands = () => {
  // 获取会话ID
  const getConversionId = useCallback((prompt: string) => {
    socketService.send({
      command: CommandType.GET_CONVERSION_ID,
      messageId: randoMessageId(),
      prompt
    });
  }, []);

  // 分析内容
  const analysis = useCallback((conversionId: string, prompt: string, imageUuid?: string[], parentStepId?: string, chatOn?: any, strategyCode?: string) => {
    socketService.send({
      command: CommandType.ANALYSIS,
      messageId: randoMessageId(),
      params: {
        conversionId,
        prompt,
        imageUuid,
        parentStepId,
        chatOn,
        strategyCode,
        lang: getLang()
      }
    });
  }, []);

  // 执行任务
  const executeTask = useCallback((conversionId: string, tasks: AnalysisTaskSubProcess[], parentStepId?: string) => {
    socketService.send({
      command: CommandType.EXECUTE_TASK,
      messageId: randoMessageId(),
      params: {
        conversionId,
        tasks,
        parentStepId
      }
    });
  }, []);


  const getSuggestions = useCallback((conversionId: string, suggestionType: suggestionProps, stepId?: string | null, cardId?: number | null, imageUuid?: string | null) => {
    socketService.send({
      command: CommandType.GEN_SUGGESTIONS,
      messageId: randoMessageId(),
      params: {
        conversionId,
        suggestionType,
        stepId,
        cardId,
        imageUuid,
        lang: getLang()
      }
    });
  }, []);

  const getImages = useCallback((imagesParams: GetImagesParams[]) => {
    socketService.send({
      command: CommandType.PUSH_IMAGES,
      messageId: randoMessageId(),
      params: imagesParams
    });
  }, [])

  return {
    getConversionId,
    analysis,
    executeTask,
    getImages,
    getSuggestions
  };
};